import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {connect} from 'react-redux';
import * as Actions from '../../store/actions';
import {
  DashboardLayout,
  PrimaryButton,
  TableLayout,
  EmptyState,
  Loader,
  PageLimit,
  Pagination,
  // SecondaryButton,
} from '../../components';
import {easyCreditCheckIc, eye, lookupEmpty} from '../../assets/images/images';
import PerformAssessmentModal from './PerformAssessmentModal';
import {useQuery} from 'react-query';
import {fetchCreditChecks} from '../../requests/queries/creditChecks';
import moment from 'moment';
import {PageContext} from '../../helpers/context';
import PageNumber from 'components/PageNumber';
const tableHeader = [
  {
    label: 'Full name',
    key: 'full_name',
  },
  {
    label: 'Phone number',
    key: 'mobile',
  },
  {
    label: 'bvn',
    key: 'bvn',
  },
  {
    label: 'status',
    key: 'status',
  },
  {
    label: 'Date/time created',
    key: 'date_created',
  },
];
function EasyCreditCheck({getAllApps, apps: {allApps}}) {
  const navigate = useNavigate();
  const [openAssessmentModal, setOpenAssessmentModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('creditcheck');
  }, [setPageName]);
  const userApps =
    allApps &&
    allApps?.apps?.map(app => ({
      value: app._id,
      label: app.name,
      name: app.name,
    }));
  useEffect(() => {
    getAllApps({limit: 10000});
  }, [getAllApps]);
  const pageClick = selected => {
    setCurrentPage(selected);
  };
  // Queries
  const {data, isLoading, isFetching} = useQuery(
    ['credit_checks', {page: currentPage, limit}],
    () => fetchCreditChecks({page: currentPage, limit}),
    {
      retry: false,
    },
  );

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Easy Credit Check</p>
      }
    >
      <PerformAssessmentModal
        open={openAssessmentModal}
        setOpen={setOpenAssessmentModal}
        userApps={userApps}
      />
      <>
        <div className="flex items-center justify-end py-2 flex-wrap gap-3 mx-[-32px] px-8 border border-transparent border-b-[#E4E3EC]">
          <PrimaryButton
            buttonText="Perform Assessment"
            onClick={() => setOpenAssessmentModal(!openAssessmentModal)}
          />
        </div>
        <TableLayout negativeMargins>
          <thead className="font-semibold uppercase">
            <tr className="bg-white80">
              {tableHeader.map(({label, key}) => (
                <th
                  key={key}
                  className={`${
                    label === 'Full name'
                      ? 'pl-4 sm:pl-6 xl:pl-8 h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap'
                      : 'pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap'
                  }`}
                >
                  <div className="flex items-end gap-1 cursor-pointer">
                    <span>{label}</span>
                  </div>
                </th>
              ))}
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td colSpan={8}>
                {isLoading ? (
                  <Loader height={45} />
                ) : data?.totalRecords === 0 && !isLoading ? (
                  <EmptyState
                    height={45}
                    body="Perform assessments with ease."
                    heading="No record found!"
                    src={lookupEmpty}
                    noBtn
                    customBtn={
                      <PrimaryButton
                        buttonText="Perform Assessment"
                        className="w-fit"
                        onClick={() =>
                          setOpenAssessmentModal(!openAssessmentModal)
                        }
                      />
                    }
                  />
                ) : null}
              </td>
            </tr>
          </tbody>

          <tbody
            className="text-sm bg-white"
            style={{opacity: isFetching ? 0.3 : 1}}
          >
            {data &&
              data?.records.map((record, index) => (
                <tr
                  className={`border-[0.5px] ${
                    record?.v_status === 'Valid' && 'cursor-pointer'
                  } border-[#E4E3EC]`}
                  key={index}
                  onClick={
                    record?.v_status === 'Valid'
                      ? () =>
                          navigate(
                            `/easy-creditcheck/credit-summary/${record?.customer_id}`,
                            {
                              state: {
                                ...record,
                              },
                            },
                          )
                      : null
                  }
                >
                  <td className="p-4 pl-4 sm:pl-6 xl:pl-8 text-body whitespace-nowrap capitalize">
                    {`${record?.first_name || '-'} ${record?.last_name || ''}`}
                  </td>
                  <td className="p-4 pl-0 text-body whitespace-nowrap">
                    {record?.mobile || '-'}
                  </td>

                  <td className="p-4 pl-0 text-body whitespace-nowrap">
                    {record?.bvn || '-'}
                  </td>

                  <td className="p-4 pl-0 text-body whitespace-nowrap">
                    <div
                      className={`px-2 pt-[5px] pb-[3px] text-xs font-medium uppercase rounded-full w-fit ${
                        record?.v_status?.toLowerCase() === 'valid'
                          ? 'text-success bg-success20'
                          : 'text-danger bg-statusBg-404'
                      }`}
                    >
                      {record?.v_status || '-'}
                    </div>
                  </td>
                  <td className="p-4 pl-0 text-body whitespace-nowrap">
                    {moment(record?.createdAt || new Date()).format(
                      'Do MMM YYYY hh:mm a',
                    )}
                  </td>
                  {record?.v_status === 'Valid' && (
                    <td className="p-4 pl-0 whitespace-nowrap">
                      <div className="flex items-center gap-4">
                        <button
                          onClick={
                            record?.v_status === 'Valid'
                              ? () =>
                                  navigate(
                                    `/easy-creditcheck/credit-summary/${record?.customer_id}`,
                                    {
                                      state: {
                                        ...record,
                                      },
                                    },
                                  )
                              : null
                          }
                          title="View"
                          // onClick={() =>
                          //   openModalWithSelectedData(verification)
                          // }
                          className="h-4 aspect-square"
                        >
                          <img src={eye} alt="" />
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </TableLayout>
        {!isLoading && data?.totalRecords > 0 && (
          <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-0 bg-white80 mx-[-32px] px-8 py-[18px] border-[0.5px] border-y-[#E4E3EC] border-transparent">
            <PageNumber
              currentPage={currentPage}
              limit={limit}
              totalCount={data?.totalRecords || 0}
            />
            <div className="flex items-center gap-5">
              <PageLimit
                onLimitChange={v => {
                  setLimit(v);
                  setCurrentPage('1'); // Reset to page 1 on limit change
                  const searchParams = new URLSearchParams(
                    document.location.search,
                  );
                  searchParams.set('limit', v);
                  searchParams.set('page', '1');
                  const newSearchParams = searchParams.toString();
                  navigate(`?${newSearchParams}`);
                }}
                total={data?.totalRecords}
                length={data?.records?.length}
                limit={limit}
              />
              <Pagination
                total={data && Math.ceil(data?.totalRecords / limit)}
                current={+currentPage}
                onPageChange={activePage => {
                  pageClick(activePage);
                  const searchParams = new URLSearchParams(
                    document.location.search,
                  );
                  searchParams.set('page', activePage);
                  const newSearchParams = searchParams.toString();
                  navigate(`?${newSearchParams}`);
                }}
              />
            </div>
          </div>
        )}
      </>
    </DashboardLayout>
  );
}
export default connect(state => state, Actions)(EasyCreditCheck);
